module.exports = __webpack_public_path__ + "assets/milk-bottle-0.4ac5672a.svg";